export const getCurrentUrl = () => {
  let currUrl: string
  try {
    currUrl = decodeURI(window.location.href)
  } catch (e) {
    // if URL contains % and it is not decoded, then we will get this error
    // and should use URL "as it is"
    console.error('Can not decode URI and use:', window.location.href)
    currUrl = window.location.href
  }
  return currUrl
}
